// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__33Oen","title":"InfoRow_title__1nPip"};